export default function() { //TODO: 현재는 key가 있는 경우만 처리 가능
  if (this.multiTooltip && this.multiTooltip()) return this;
  this.__execs__.tooltip.hide();
  return this;
}


// WEBPACK FOOTER //
// ./layouts/default/hideTooltip.js